const INITIAL_STATE = {
    isLogged: false,
    user: {},
    authorization: '',
    status: 'not_requested',
    message: null,
    logonStatus: 'done',
    language: ''
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'USER_LOGGED':
            return {
                    ...state,
                    isLogged: true,
                    user: action.payload.user,
                    authorization: action.payload.authorization,
                }
        case 'USER_LOGOFF':
            return { ...state, isLogged: false, user: {}, authorization: ''}
        case 'AUTH_UPDATED':
            return { ...state, authorization: action.payload}
        case 'USER_UPDATED':
            return { ...state, isLogged: true, user: action.payload}
        case 'LOGIN_CHANGED_STATUS':
            return { ...state, status: action.payload.status, message: action.payload.message }
        case 'LOGIN_LOGON_STATUS': 
            return { ...state, logonStatus: action.payload }
        case 'LANGUAGE':
            return { ...state, language: action.payload }
        case 'CHANGED_STATUS':
            return { ...state, status: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/loginReducer.js